<template>
  <div ref="root" class="chart-widget">
    <h2 v-if="title" class="chart-widget__title h2">{{ title }}</h2>

    <p v-if="isEmpty" class="chart-widget__empty t2">{{ t('empty') }}</p>

    <!-- Линию рисует Highstock после монтирования: библиотека завязана на DOM.
         До загрузки данных контейнер держит высоту, чтобы текст статьи
         не прыгал. -->
    <div ref="chartEl" class="chart-widget__chart" />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from '#imports';
  import { useChartWidgetModel } from './model';
  import type { ChartWidgetProps } from './types';

  const props = withDefaults(defineProps<ChartWidgetProps>(), {
    template: 'default',
    period: undefined,
    start: undefined,
    end: undefined,
    currency: undefined,
    title: '',
    fill: true,
  });

  const { t } = useI18n({ useScope: 'local' });

  const { root, chartEl, isEmpty } = useChartWidgetModel(props, t);
</script>

<style lang="scss">
  @use './style';
</style>

<i18n lang="json" src="./locale.json" />
